// extracted by mini-css-extract-plugin
export var section = "section-module--section--gM98C";
export var title = "section-module--title--XLKv0";
export var line = "section-module--line--wWS75";